import classNames from 'classnames';

import { iconDefaults } from '.';
import { IconProps as Props } from '../types/hubInterfaces';

function ExclamationMarkCircleIcon(props: Props) {
  const { width, height, className } = { ...iconDefaults, ...props };
  return (
    <svg
      className={classNames('fill-current', className)}
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_4216_57154)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V12.75C12.75 13.1642 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.1642 11.25 12.75V9C11.25 8.58579 11.5858 8.25 12 8.25ZM12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75C12.75 15.3358 12.4142 15 12 15C11.5858 15 11.25 15.3358 11.25 15.75C11.25 16.1642 11.5858 16.5 12 16.5Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_4216_57154">
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { ExclamationMarkCircleIcon };
